import React from 'react';
import { useParams } from 'react-router-dom';
import {
  ComponentEntityLayout,
  ApiEntityLayout,
  UserEntityLayout,
  GroupEntityLayout,
  SystemEntityLayout,
  DomainEntityLayout,
  ResourceEntityLayout,
  DefaultEntityLayout,
} from './layouts';

const KIND_LAYOUTS: Record<string, React.ComponentType> = {
  component: ComponentEntityLayout,
  api: ApiEntityLayout,
  group: GroupEntityLayout,
  user: UserEntityLayout,
  system: SystemEntityLayout,
  domain: DomainEntityLayout,
  resource: ResourceEntityLayout,
};

export const EntityPage = () => {
  const { kind = '' } = useParams();
  const Layout = KIND_LAYOUTS[kind.toLowerCase()] ?? DefaultEntityLayout;
  return <Layout />;
};
